"use strict";

var _taggedTemplateLiteral = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n    margin-right: ", "px;\n  "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n    margin-right: 12px;\n  "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n          margin: 0 ", "px\n            ", "px 0;\n        "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n          margin-right: ", "px;\n        "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n          margin-right: ", "px;\n        "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        bottom: 0;\n        right: 0;\n        margin: 0 12px 16px 0;\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        height: 100%;\n        top: 0;\n        left: auto;\n        right: 0;\n        align-self: flex-end;\n        margin-right: 36px;\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        height: 100%;\n        margin-right: 12px;\n        top: 0;\n        left: auto;\n        right: 0;\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  position: absolute;\n  width: 24px;\n  border-radius: 8px;\n  align-items: center;\n  pointer-events: none;\n  background: transparent;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.focusedInputSelectIcon = exports.inputSelectIcon = exports.focusVariations = exports.spinIconLoading = exports.inputVariations = exports.inputIconBase = void 0;

var _stylitas = require("@creditas/stylitas");

var _consts = require("./consts");

var inputIconBase = function inputIconBase() {
  return (0, _stylitas.css)(_templateObject());
};

exports.inputIconBase = inputIconBase;

var inputVariations = function inputVariations(_ref) {
  var relatedInputType = _ref.relatedInputType;

  switch (relatedInputType) {
    case 'input':
      return (0, _stylitas.css)(_templateObject2());

    case 'select':
      return (0, _stylitas.css)(_templateObject3());

    case 'textarea':
      return (0, _stylitas.css)(_templateObject4());

    default:
      return (0, _stylitas.css)(_templateObject5());
  }
};

exports.inputVariations = inputVariations;

var spinIconLoading = function spinIconLoading(_ref2) {
  var variant = _ref2.variant;
  return variant === 'loading' && (0, _stylitas.css)(_templateObject6(), _stylitas.utilities.animation.spin());
};

exports.spinIconLoading = spinIconLoading;

var focusVariations = function focusVariations(_ref3) {
  var relatedInputType = _ref3.relatedInputType,
      inputFocus = _ref3.inputFocus,
      readOnly = _ref3.readOnly;

  if (inputFocus && !readOnly) {
    switch (relatedInputType) {
      case 'input':
        return (0, _stylitas.css)(_templateObject7(), 12 - _consts.FOCUSED_BORDER_DELTA);

      case 'select':
        return (0, _stylitas.css)(_templateObject8(), 36 - _consts.FOCUSED_BORDER_DELTA);

      case 'textarea':
        return (0, _stylitas.css)(_templateObject9(), 12 - _consts.FOCUSED_BORDER_DELTA, 16 - _consts.FOCUSED_BORDER_DELTA);

      default:
        return (0, _stylitas.css)(_templateObject10());
    }
  } else {
    return (0, _stylitas.css)(_templateObject11());
  }
};

exports.focusVariations = focusVariations;

var inputSelectIcon = function inputSelectIcon(_ref4) {
  var selectIcon = _ref4.selectIcon;
  return selectIcon && (0, _stylitas.css)(_templateObject12());
};

exports.inputSelectIcon = inputSelectIcon;

var focusedInputSelectIcon = function focusedInputSelectIcon(_ref5) {
  var selectIcon = _ref5.selectIcon,
      inputFocus = _ref5.inputFocus;
  return selectIcon && inputFocus && (0, _stylitas.css)(_templateObject13(), 12 - _consts.FOCUSED_BORDER_DELTA);
};

exports.focusedInputSelectIcon = focusedInputSelectIcon;